/** The values the link texts name. */
type SsoLinkVars = { tenant: string; provider: string; email: string };

export const T = {
  en_GB: {
    title: "Connect single sign-on",
    intro: (v: SsoLinkVars) =>
      `The ${v.provider} account below signed in to ${v.tenant} using ${v.email}. Confirm to connect it to your Quantfolio account.`,
    identity: (v: SsoLinkVars) => `${v.provider} account`,
    unknownIdentity: (v: SsoLinkVars) => `Name not provided by ${v.provider}`,
    consequences: (v: SsoLinkVars) =>
      `After this you sign in with ${v.provider} only. Your Quantfolio password and two-factor authentication are removed. Your history and permissions stay.`,
    notYou: "If this wasn't you, don't confirm. Close this page and tell your administrator.",
    confirm: (v: SsoLinkVars) => `Confirm and sign in with ${v.provider}`,
    continue: (v: SsoLinkVars) => `Continue with ${v.provider}`,
    invalid:
      "This link is invalid or has expired. Sign in with single sign-on again to get a new one.",
    wrongUser: (email: string) =>
      `You are signed in as ${email}, but this link was sent to another user. Sign out and sign in as the user it was sent to.`,
    signOut: "Sign out",
    lastPasswordAdmin: (v: SsoLinkVars) =>
      `Your account is the last administrator in ${v.tenant} who can sign in without single sign-on, so it can't be connected. Ask another administrator to give a second user with a password the admin permission first.`,
    failed: "Something went wrong. Please try again.",
    sso: "single sign-on",
  },
  nb_NO: {
    title: "Koble til single sign-on",
    intro: (v: SsoLinkVars) =>
      `${v.provider}-kontoen nedenfor logget inn i ${v.tenant} med e-postadressen ${v.email}. Bekreft for å koble den til Quantfolio-kontoen din.`,
    identity: (v: SsoLinkVars) => `${v.provider}-konto`,
    unknownIdentity: (v: SsoLinkVars) => `Navn ikke oppgitt av ${v.provider}`,
    consequences: (v: SsoLinkVars) =>
      `Etter dette logger du bare inn med ${v.provider}. Quantfolio-passordet og tofaktorautentiseringen din fjernes. Historikken og tilgangene dine beholdes.`,
    notYou: "Hvis dette ikke var deg, ikke bekreft. Lukk siden og si fra til administratoren din.",
    confirm: (v: SsoLinkVars) => `Bekreft og logg inn med ${v.provider}`,
    continue: (v: SsoLinkVars) => `Fortsett med ${v.provider}`,
    invalid:
      "Lenken er ugyldig eller utløpt. Logg inn med single sign-on på nytt for å få en ny lenke.",
    wrongUser: (email: string) =>
      `Du er logget inn som ${email}, men denne lenken ble sendt til en annen bruker. Logg ut og logg inn som brukeren den ble sendt til.`,
    signOut: "Logg ut",
    lastPasswordAdmin: (v: SsoLinkVars) =>
      `Kontoen din er den siste administratoren i ${v.tenant} som kan logge inn uten single sign-on, så den kan ikke kobles til. Be en annen administrator gi en annen bruker med passord administratortilgang først.`,
    failed: "Noe gikk galt. Prøv igjen.",
    sso: "single sign-on",
  },
} as const;
